// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // Implicit Flow Configuration
    REACT_APP_SPA_URL: "https://owner-summary.platform-tools.vacasastage.services",

    REACT_APP_SPA_IDP_AUDIENCE: ["genai.data-science.vacasastage.com"].join(" "),

    REACT_APP_SPA_IDP_SCOPES: ["owner-summary:read"].join(" "),

    // IDP Vars
    REACT_APP_IDP_URL: "https://stage.accounts.vacasa.io",
    REACT_APP_IDP_REDIRECT_URI: "https://owner-summary.platform-tools.vacasastage.services",
    REACT_APP_IDP_CLIENT_ID: "K1gy7OnhR82HmBupDxUl0YTUvCXrKcVJFZWAVuK6",

    // Datadog
    REACT_APP_DD_URL: "datadoghq.com",
    REACT_APP_DATADOG_TOKEN: "pubd8574179531d421033334cd5dbf819ed",

    // Services
    REACT_APP_GENAI_SERVICE_URL: "https://genai.data-science.vacasastage.com/api",
    REACT_APP_OWNER_SUMMARY_SERVICE_URL: "https://owner-summary.vacasastage.io/v1",
    REACT_APP_ADMIN_URL: "https://admin.vacasastage.com",

    // Salesforce
    REACT_APP_SALESFORCE_URL: "https://vacasa--uat.sandbox.lightning.force.com",

    // Config files
    OWNER_SUMMARY_CONFIG_FILE: "https://cdn.owner-summary.vacasastage.services/config.json",
};
